module.exports = __webpack_public_path__ + "static/media/barefoot_zoo.b2281094.jpg";